import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const MaskedLines = ({ lines, className = "", lineClassName = "", delay = 0, as: Tag = "h1" }) => (
  <Tag className={className}>
    {lines.map((line, i) => (
      <span key={i} className="block overflow-hidden pb-[0.08em] -mb-[0.08em]">
        <motion.span
          className={`block ${lineClassName}`}
          initial={{ y: "110%" }}
          animate={{ y: "0%" }}
          transition={{ duration: 1, delay: delay + i * 0.14, ease: EASE }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </Tag>
);

export const FadeUp = ({ children, delay = 0, className = "", y = 28 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.9, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children, dark = false, className = "" }) => (
  <p
    className={`font-mono text-xs uppercase tracking-[0.25em] flex items-center gap-3 ${
      dark ? "text-bronzo" : "text-bronzo"
    } ${className}`}
  >
    <span className="inline-block w-8 h-px bg-bronzo" aria-hidden="true" />
    {children}
  </p>
);
